/**
 *
 * @param {string} param Parametro a evaluar
 * @param {string} newval nuevo valor a ubicar
 * @param {string} search urlString
 * @returns
 */
export default function replaceQueryParam(param, newval, search) {
  let regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
  let query = search.replace(regex, "$1").replace(/&$/, "");

  return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : "");
}
